import cx from 'classnames';
import styles from './SkeletonLoaderUI.module.scss';
import card from '../common/ThumbnailCardUI.module.scss';
import cardContainer from '../common/ThumbnailContainerV2.module.scss';
import { memo, useEffect, useState } from 'react';
import { SkeletonUI, SKELETON_CARD_SIZE, SKELETON_LAYOUT } from './SkeletonLoaderUI';

const ThumbnailCardLoaderUI = memo(({ containerStyle, className, reference, size, layout, extraSmallLoaderCard }) => {

  const [noOfCards, setNoOfCards] = useState(1)

  const cardWidth = size === SKELETON_CARD_SIZE.SMALL ? 200 : 272;
  const cardHeight = size === SKELETON_CARD_SIZE.SMALL ? 200 : 272;

  const handleWindowResize = () => {
  
    const windowWidth = window.innerWidth - 250;
    const windowHeight = window.innerHeight - 300;

    // const num = (size === SKELETON_CARD_SIZE.SMALL && layout === SKELETON_LAYOUT.VERTICAL)
    //       ? Math.round(windowHeight/cardHeight) 
    //       : Math.round(windowWidth/cardWidth) * Math.round(windowHeight/cardHeight);

    let num = 1;

    if(layout === SKELETON_LAYOUT.HORIZONTAL) {
      num = Math.floor(windowWidth/cardWidth);
    } else if(layout === SKELETON_LAYOUT.VERTICAL) {
      num = Math.round(windowHeight/cardHeight);
    } else if(layout === SKELETON_LAYOUT.GRID) {
      num = Math.floor(windowWidth/cardWidth);
    }
    setNoOfCards(num);
  
  }

  useEffect(() => {

    handleWindowResize()

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);

  }, [])

  const placeholders = noOfCards > 0 && Array.from(Array(noOfCards).keys()).map(a => {
    return (
      <div key={a} className={cx(className, 'thumbnail-card mb-0', size === SKELETON_CARD_SIZE.SMALL && 'smallThumbCard', styles.thumbnailCard)}>
        <div>
          <div className={styles.image}></div>
        </div>
        <div className={`px-3 ${size === SKELETON_CARD_SIZE.SMALL ? 'pt-2 pb-2' : 'pt-1 pb-1'}`}>
          <SkeletonUI count={1} />
          {
            size !== SKELETON_CARD_SIZE.SMALL
            &&
            <div className={styles.inline}>
              <SkeletonUI count={1} width={20} height={20} style={{ marginRight: '4px' }} />
              <SkeletonUI count={1} width={100}  style={{ marginTop: '8px' }} />
            </div>
          }
        </div>
      </div>
  )})

  return size === SKELETON_CARD_SIZE.SMALL ? (
    placeholders
  ) : (
    <div
      className={extraSmallLoaderCard ? cardContainer.popupGrid : cardContainer.grid}
      style={containerStyle}>
      {placeholders}
    </div>
  );
});

export default ThumbnailCardLoaderUI

